'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M84.1 216.8L171 306.2l11 11.3-2.2 15.6L162 456.5l110-54.1L272 99l-42.1 79.9-7.3 13.9L207 195.5 84.1 216.8z', 'M306.1 34.3L374.6 164 519 189l38.2 6.6-27 27.8L428 328.5l20.9 145.1 5.5 38.4-34.8-17.1L288.1 430.2 156.5 494.9 121.7 512l5.5-38.4 20.9-145.1L45.9 223.4l-27-27.8L57.1 189l144.5-25L270 34.3 288.1 0l18.1 34.3zm63 161.2l-15.5-2.7-7.3-13.9L304 98.8l0 303.6 110.1 54.1L396.4 333.1l-2.2-15.6 11-11.3L492 216.8 369.1 195.5zM272 99l-42.1 79.9-7.3 13.9L207 195.5 84.1 216.8 171 306.2l11 11.3-2.2 15.6L162 456.5l110-54.1L272 99z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;